import React from "react";
import Button from "Components/button/Button";
import DeliveryVolumeSelection from "Components/deliveryVolumeSelection/DeliveryVolumeSelection";
import t from "Utils/translation";
import { deliveryPlans } from "@/config";

const ExtraMessages = ({
  formData,
  stepper,
  onFormCancel,
  nextStep,
  setFormFieldValue,
  actualVolume,
  isExtradelivery,
  accountData,
  isReseller,
  isEditPlanVolume,
}) => {
  return (
    <div className="flex flex-col items-center h-full px-4 pt-4">
      {stepper}

      <div className="mt-4 w-full max-w-[--form-page-width]">
        <div className="sectionTitle">{t("delivery.accounts.extradelivery.title")}</div>
        <div className="sectionDesc">{t("dashboard.extraDelivery.desc")}</div>
      </div>
      <div className="w-full h-full max-w-[--form-page-width] flex flex-col items-center justify-between">
        <div className="flexColumnContainer">
          <DeliveryVolumeSelection
            name="volume"
            className="mt-9"
            showSlider={formData.plan !== deliveryPlans.FREE}
            formValue={formData.volume}
            title={t("delivery.accounts.add.extraDelivery.packages.title")}
            onChange={setFormFieldValue}
            accountData={accountData}
            isExtradelivery={isExtradelivery}
            isReseller={isReseller}
          />
        </div>
        <div className="flexColumnContainer">
          <div className="formFooter">
            <Button color="text" type="button" onClick={onFormCancel}>
              button.cancel
            </Button>
            <Button onClick={nextStep} color="accent">
              button.continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtraMessages;
